import { render, staticRenderFns } from "./BuyerCreateSoftphoneCampaign.vue?vue&type=template&id=7ece329a&scoped=true"
import script from "./BuyerCreateSoftphoneCampaign.vue?vue&type=script&lang=js"
export * from "./BuyerCreateSoftphoneCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ece329a",
  null
  
)

export default component.exports